
import { Policy } from "@/types";
import { corePolicies } from "./policyData";
import { additionalPolicies } from "./additionalPolicies";
import { draftPolicies } from "./draftPolicies";

// Combine all policies for the main export
export const samplePolicies: Policy[] = [
  ...corePolicies,
  ...additionalPolicies,
  ...draftPolicies
];

// Export individual policy groups for more granular access
export * from "./policyData";
export * from "./additionalPolicies";
export * from "./draftPolicies";
